import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption } from '../modules/tcm-core.module';
import { PatientReferringPhysicianOption } from '../models/patients';
import { ReferringPhysicianListOptionRequest } from '../models/referring-physician';

@Injectable({
  providedIn: 'root'
})
export class ReferringPhysicianDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  getReferringPhysicianOptionsAsync(query: string, referringPhysicianId: number = null, timeout: Promise<any>): Promise<ListOption<number>[]> {
    const request: ReferringPhysicianListOptionRequest = { searchString: query, referringPhysicianId: referringPhysicianId };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('ReferringPhysicians/Options', request, timeout, false);
  }

  checkPatientReferringPhysicianExists(patientId: number, referringPhysicianId: number, id: number, timeout: Promise<any>): Promise<boolean> {
    const data = { referringPhysicianId: referringPhysicianId, patientId: patientId, id: id };
    return this.httpClient.getJsonAsync<boolean>('PatientReferringPhysicians/CheckPatientReferringPhysicianExists', data, timeout, false);
  }
}
